define('views/pages/FidelityPageView',['underscore', 'jquery', 'backbone', 'app', 'PageView',
    'InternalLinkView',

], function (_, $, Backbone, app, PageView,
             InternalLinkView
             ) {
    
    


    var FidelityPageView = PageView.extend({
        pageName: 'FidelityPage',
        fslideActive: 0,
        events: {
	  'click .fslider-nav button': "onFsliderNavClick",
            'mouseenter .table-head': 'tableHeaderMouseenter',
            'mouseleave .table-head': 'tableHeaderMouseleave'
        },
     onFsliderNavClick: function(e){
                var view = this;
                if($(e.currentTarget).hasClass('inactive')){
                    return;
                }
                if($(e.currentTarget).hasClass('next')){
                    view.fslideTo(view.fslideActive + 1);
                }else if($(e.currentTarget).hasClass('prev')){
                    view.fslideTo(view.fslideActive - 1);
                }
            },
            fslideTo: function(id){
                var view = this;
                view.fslideActive = id;
                view.$('.fslider-list').css('left', - id * 100 + '%');
                view.$('.fslider-nav .next').toggleClass('inactive', view.fslideActive >= view.$('.fslider-item').length - 1);
                view.$('.fslider-nav .prev').toggleClass('inactive', view.fslideActive <= 0);
            },


        tableHeaderMouseenter: function(e){
            var nb = $(e.currentTarget).data('nb');
            $(e.currentTarget).addClass('active');
            $('.border').removeClass('active').filter(function () {
                return $(this).data('cat').toString().indexOf(nb.toString()) >= 0;
            }).addClass('active');
        },
        tableHeaderMouseleave: function(e){
            $(e.currentTarget).removeClass('active');
            $('.border').removeClass('active');
        },

    })

    return FidelityPageView;

})
;
